/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* Accedo Build XDK Core (@accedo/xdk-core) 4.1.4
* 
*******************************************************************************/
export default{TYPE:{CELLULAR:"cellular",DISCONNECTED:"disconnected",ETHERNET:"ethernet",UNKNOWN:"unknown",WIFI:"wifi"},DEFAULT:{IPv4:"0.0.0.0",IPv6:"dummyIPv6",MAC_ADDRESS:"dummyMAC",SSID:"dummySSID",SIGNAL_STRENGTH:"dummySignalStrength"}};